// Season 2 premiere — 3:00 PM Eastern. Edit this one value to move the countdown.
export const SEASON_2_PREMIERE_ISO = '2026-10-02T15:00:00-04:00'

export interface Season2Episode {
  id: number
  title: string
  guest: string
  hometown: string
  spotifyUrl: string
  image: string
  imageAlt: string
  hook: string
  duration: string
  description: string[]
  journey: { label: string; detail: string }[]
}

export const season2Premiere: Season2Episode = {
  id: 1,
  title: 'From Rooftops to War to Redemption & Identity',
  guest: '"Jim"',
  hometown: 'Washington',
  spotifyUrl:
    'https://open.spotify.com/episode/2OJFfVbAWWVtmGsDGdtaBt?si=ZyD_d45hSbedBlbekO8T4Q',
  image:
    'https://cdn.magicpatterns.com/patterns/generated-images/cddae6c7-02f5-4e67-bbfc-7967057c7358.jpg',
  imageAlt: 'A man sitting alone on a rooftop at dusk overlooking a small town',
  hook: 'Homeless on the rooftops. Deployed to Iraq. Found by God in the middle of it all.',
  duration: '',
  description: [
    '"Jim," whose name we have changed, began his story on a farm in Washington, where his grandparents raised him after his mother gave birth at 15. After a family tragedy, he found himself homeless, sometimes sleeping on rooftops and wondering where life would take him.',
    'A Greyhound bus brought him to Florida. He married Rochelle, joined the Army, and deployed to Iraq as a combat engineer. Surrounded by danger and far from home, "Jim" began reading the Bible. As he surrendered his life to God, he found a peace he hadn\'t known before.',
    'In this episode of the Three Doves Podcast, "Jim" shares what it was like to watch his first child\'s birth over Skype, how his faith grew after returning home, and why his work in law enforcement gave him a renewed sense of brotherhood. Through it all, he has learned to put God, his wife, and his children first.',
  ],
  journey: [
    {
      label: 'Rooftops',
      detail: 'Raised on a Washington farm, then homeless after a family tragedy.',
    },
    {
      label: 'War',
      detail: 'A Greyhound to Florida, the Army, and a deployment to Iraq.',
    },
    {
      label: 'Redemption',
      detail: 'A Bible in a war zone, and a peace he had never known.',
    },
    {
      label: 'Identity',
      detail: 'God first, then his wife and children — and a new brotherhood.',
    },
  ],
}

export const season2Episode2: Season2Episode = {
  id: 2,
  title: 'Faith Beyond the Ballot',
  guest: 'Matt Caldwell',
  hometown: 'Fort Myers, Florida',
  spotifyUrl:
    'https://open.spotify.com/episode/3ioYjgxAmMbm4eHyFefThi?si=fbd356d537844ae3',
  image:
    'https://cdn.magicpatterns.com/patterns/generated-images/831cc512-691b-4097-a93d-67a1df369ed5.jpg',
  imageAlt:
    'A man walking up the steps of a columned civic building at golden hour with a church steeple in the distance',
  hook: "What happens when life doesn't go the way you planned? When the doors you thought God was opening suddenly close? Jason sits down with Matt Caldwell to talk faith, family, politics, and discovering God's purpose through life's unexpected challenges.",
  duration: '47 min',
  description: [
    "What happens when life doesn't go the way you planned? When the doors you thought God was opening suddenly close?",
    "On this episode of the Three Doves Podcast, host Jason Pawloski sits down with Matt Caldwell to talk about faith, family, politics, and discovering God's purpose through life's unexpected challenges.",
    'Growing up in Fort Myers, Florida, Matt developed a strong foundation that has carried him through public life and private setbacks alike — and taught him that faith runs deeper than any ballot.',
  ],
  journey: [
    {
      label: 'Roots',
      detail: 'Growing up in Fort Myers, Florida, on a strong foundation.',
    },
    {
      label: 'Public Life',
      detail: 'Faith, family, and politics — and how they fit together.',
    },
    {
      label: 'Closed Doors',
      detail: 'When the doors he thought God was opening suddenly closed.',
    },
    {
      label: 'Purpose',
      detail: "Discovering God's purpose through life's unexpected challenges.",
    },
  ],
}

// All Season 2 episodes, newest first. Add new episodes to the top.
export const season2Episodes: Season2Episode[] = [
  season2Episode2,
  season2Premiere,
]

// The newest Season 2 episode — featured at the top of the homepage.
export const latestSeason2Episode: Season2Episode = season2Episodes[0]
